export const UserApiUrls = {
  users: '/api/user/userlist',
  save: '/api/user/save',
  roles: '/api/user',
  assignrole: '/api/user/assignrole',
  usernameexsist: '/api/user/usernameexsist',
  usersites: '/api/site/usersites',
  saveusersites: '/api/site/saveusersites',
  usersbyrole: '/api/role/users',
  usernumexists: '/api/user/numberexists',
  regions:'/api/user/regions',
  organisations:'/api/user/organisations'

};
